// import React from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { SIGN_OUT } from '../api/mutations';
import { toast } from 'react-toastify';

export default function Logout() {
  const client = useApolloClient();
  const history = useHistory();

	const [singout] = useMutation(SIGN_OUT, {
		onCompleted: (data) => {
			// Wipe the Apollo cache before navigating away — otherwise the next
			// user (or admin returning from impersonation) can briefly see the
			// previous user's normalized entries (e.g. myProfile fields) before
			// the fresh queries land. Refresh used to be the only workaround.
			client.clearStore().finally(() => {
				history.push("/");
			});
		}
	});

	if (localStorage.getItem("auth_token") || localStorage.getItem("user_type")){
		singout({
			variables: {}
		});
		localStorage.clear();
	} else {
		history.push("/");
	}

  // localStorage.removeItem('admin_token');
  // localStorage.removeItem('auth_token');
  // localStorage.removeItem('user_token');
  // localStorage.removeItem('assistant_token');
  // localStorage.removeItem('user_type');
  // localStorage.removeItem('user_name');
  // localStorage.removeItem('filter_token');

  return null;
};
